module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/x2rRKr/tc-custom/9781609454340.jpg?1734322226510",
      "alt": "This image is the cover for the book Nothing But Dust"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Nothing But Dust\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Winner of the Landerneau Prize for Crime Fiction: “A combination of a South American Western and a noir [with] airs of Faulknerian tragedy” ("), _c('i', [_vm._v("Lire")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" By the time Rafael is born, the family farm has already gone to hell. Rafael’s father has abandoned them. His older twin brothers blame Rafael for their father’s departure and exact revenge. Rafael’s other sibling is a simpleton whose affections and allegiances change with the shifting winds. And ruling over this dysfunctional roost is a tyrannical and avaricious mother."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" On the lonely Patagonian steppe, life is lived to the rhythms of the family farm. But there is nothing bucolic about the existence described in these pages: It is ruthless, unforgiving, and bloody. As the family tensions mount, daily life degenerates into open warfare, in a gripping, unsentimental, ultimately majestic story about life in one the most inhospitable places on Earth.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sandrine Collette\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Europa Editions\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0